@if (title()) {
  <p class="px-3 pt-1 pb-1.5 text-xs font-semibold text-base-content/50">{{ title() }}</p>
}
<ul class="flex w-full flex-col">
  @for (item of items(); track item.label) {
    <li>
      <a
        [routerLink]="item.link"
        [attr.href]="item.href"
        [attr.target]="item.href ? '_blank' : null"
        [attr.rel]="item.href ? 'noopener noreferrer' : null"
        class="flex cursor-pointer items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-colors hover:[background:var(--border-color-contrast)]"
        (click)="item.action ? item.action() : linkClick.emit()"
      >
        <span class="flex w-9 shrink-0 justify-center">
          <ui-icon [name]="item.icon" [size]="20"></ui-icon>
        </span>
        {{ item.label }}
        @if (item.badge) {
          <span class="badge badge-sm rounded-full border-none bg-purple/45 font-semibold text-ink">{{ item.badge }}</span>
        }
        @if (item.external) {
          <ui-icon class="ml-auto text-base-content/50" name="external-link" [size]="16"></ui-icon>
        }
      </a>
    </li>
  }
</ul>
